import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import type { GuideFrontmatter } from "../../../lib/help/types";

export function GuideCard({ guide }: { guide: GuideFrontmatter }) {
  return (
    <Link
      to={`/help/guides/${guide.slug}`}
      className="paper-card group flex h-full flex-col justify-between rounded-2xl border border-cream-300 bg-cream-50 p-6 transition-all hover:-translate-y-0.5 hover:border-forest-300 hover:shadow-lg"
    >
      <div>
        <h3 className="font-display text-xl font-semibold text-bark-900 group-hover:text-forest-700">
          {guide.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-bark-700">{guide.description}</p>
      </div>
      <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-forest-700">
        Read guide
        <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </span>
    </Link>
  );
}
